import { render, staticRenderFns } from "./JourneyContainer.vue?vue&type=template&id=1bb4d956&scoped=true&"
import script from "./JourneyContainer.vue?vue&type=script&lang=js&"
export * from "./JourneyContainer.vue?vue&type=script&lang=js&"
import style0 from "./JourneyContainer.vue?vue&type=style&index=0&id=1bb4d956&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4d956",
  null
  
)

export default component.exports